import { useTranslation, Trans } from 'react-i18next'
import styled from 'styled-components'
import { colors, fontWeights } from '@/styles'
import { Input } from '@/components/form'

interface ContainerProps {
  altStyle: boolean
}

const AgreeLabel = styled.label`
  font-size: 16px;
  line-height: 28px;
  letter-spacing: -0.5px;
  text-align: left;
`

const Link = styled.a`
  color: ${colors.regular};
  font-weight: ${fontWeights.regular};
  text-decoration: underline;
`

const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: space-between;
  flex-direction: ${props => (props.altStyle ? 'row-reverse' : 'row')};
  align-items: ${props => (props.altStyle ? 'flex-start' : 'center')};
  margin: 16px 0 12px;
  ${props =>
    props.altStyle &&
    `
    > :last-child {
      margin: 8px 12px 0 0;
    }
  `}
`

type AgreeToTermsProps = {
  setAgreed: (s: boolean) => void
  showAgeGate?: boolean
  altStyle?: boolean
}

const AgreeToTerms: React.FC<AgreeToTermsProps> = ({
  setAgreed,
  showAgeGate = false,
  altStyle = false
}) => {
  const { t } = useTranslation()
  return (
    <Container altStyle={altStyle}>
      {showAgeGate ? (
        <Trans i18nKey="b.appointment.modal.agree_terms_privacy.text" t={t}>
          <AgreeLabel htmlFor="agree_to_terms">
            By checking this, I confirm that I am over 13 years old and that I have read and agree
            to liv.rent{`'`}s{' '}
            <Link href="https://liv.rent/terms" target="_blank" rel="noopener noreferrer">
              Terms & Conditions
            </Link>{' '}
            and{' '}
            <Link href="https://liv.rent/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </Link>
            .
          </AgreeLabel>
        </Trans>
      ) : (
        <Trans i18nKey="b.appointment.modal.agree_terms_privacy_no_age_gate.text" t={t}>
          <AgreeLabel htmlFor="agree_to_terms">
            I have read and agree to the terms above and liv.rent{`'`}s{' '}
            <Link href="https://liv.rent/terms" target="_blank" rel="noopener noreferrer">
              Terms & Conditions
            </Link>
            .
          </AgreeLabel>
        </Trans>
      )}
      <Input
        id="agree_to_terms"
        name="agree_to_terms"
        type="checkbox"
        onChange={e => setAgreed(e.target.checked)}
      />
    </Container>
  )
}

export default AgreeToTerms
